import {styled} from "@mui/material";

export const LayoutWrapperStyle = styled('div')(() => ({

}))